module.exports = __webpack_public_path__ + "static/media/sna.22237a99.jpeg";